import { Component, EventEmitter, Input, Output, ViewChild, AfterViewInit } from '@angular/core';

import { MenuItem } from 'primeng/primeng';

import { CUIRowGroupColumn } from './cui-rowgroup-column';
import { CUIRowGroupHeaderInfo } from './cui-rowgroup-header-info';

@Component({
    selector: 'cui-rowgroup',
    templateUrl: './cui-rowgroup.component.html'
})
export class CUIRowGroupComponent implements AfterViewInit {
    @Input() actionsHeader: string = 'Actions';
    @Input() table_id: string;
    @Input() columns: CUIRowGroupColumn[] = [];
    @Input() data: any[] = [];
    @Input() groupField: string;
    @Input() icon: string;
    @Input() groupHeaderInfo: Array<CUIRowGroupHeaderInfo[]> = [];
    @Input() rowsPerPage: number = 10;
    @Input() totalRecords: number = 0;
    @Input() enableHeaderAction: boolean = false;
    @Input() enableRowAction: boolean = false;
    @Input() headerActionIcon: string;
    @Input() rowActionIcon: string;
    @Input() hideToolbar: boolean = false;
    @Output() onHeaderAction: EventEmitter<any> = new EventEmitter();
    @Output() onRowAction: EventEmitter<any> = new EventEmitter();
    @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
    @ViewChild('dataTable') table;

    globalFilter: string;
    tableWidth: number;
    filterDelay: number = 300;
    filterTimeout = null;

    ngAfterViewInit() {
        this.identifyTableWidth();
        
    }

    /**
     * @function emits a onLazyLoad event to the implementing feature component
     * @returns void
     */
    emitLazyLoad(event): void {
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
            this.onLazyLoad.emit({
                filter: this.globalFilter,
                first: event.first,
                rows: event.rows,
                sortField: event.sortField,
                sortOrder: event.sortOrder
            });

            this.filterTimeout = null;
        }, this.filterDelay);

    }

    /**
     * @function emits a onHeaderAction event to the implementing feature component
     * @returns void
     */
    emitOnHeaderAction(data): void {
        this.onHeaderAction.emit(data);
    }

    /**
     * @function emits a onRowAction event to the implementing feature component
     * @returns void
     */
    emitOnRowAction(data): void {
        this.onRowAction.emit(data);
    }

    getColumnWidth(): number {
        return Math.ceil((this.tableWidth - 120) / this.columns.length); /* total width minus the actions column width */
    }

    getHeaderInfo(header: string): CUIRowGroupHeaderInfo[] {
        return this.groupHeaderInfo.find(item => item[0].value == header);
    }

    identifyTableWidth() {
        this.tableWidth = this.table.el.nativeElement.firstElementChild.offsetWidth;
    }

    onResize(event) {
        this.identifyTableWidth();
    }

    groupDevice(header) {
        let styleNameellipsis = { 'overflow': 'hidden', 'white-space': 'nowrap', 'text-overflow': 'ellipsis', 'text-align': 'center'};
        let styleNamecenter = { 'text-align': 'center' };
        if (header == 'Group/Device') {
            return styleNameellipsis;
        }
        else if (header == 'Action' || header == 'Schedule' || header == 'Last Ran' || header == 'Next Run') {
            return styleNamecenter;
        }
    }

}

@Component({
    selector: 'cui-rowgroup-header',
    template: `
        <span *ngFor="let info of headerInfo" [style.margin-left]="getStyle(info.index)" class="header-info">{{ info.value }}</span>
    `
})
export class CUIRowGroupHeaderComponent {
    @Input() headerInfo: CUIRowGroupHeaderInfo[];
    @Input() columnWidth: number;

    getStyle(index: number): string {
        if (index === 0)
            return '0px';
        return ((this.columnWidth + index) * index) - 13 + 'px';
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-rowgroup/cui-rowgroup.component.ts